module.exports = __webpack_public_path__ + "img/finance.c571aa70.svg";